Object.defineProperty(exports, "__esModule", {
  value: true
});

var component_1 = require("@loadable/component");

var Code = component_1.default(function () {
  return Promise.resolve().then(function () {
    return require('./code');
  });
});
var Html = component_1.default(function () {
  return Promise.resolve().then(function () {
    return require('./html');
  });
});
var Preformatted = component_1.default(function () {
  return Promise.resolve().then(function () {
    return require('./preformatted');
  });
});
var Pullquote = component_1.default(function () {
  return Promise.resolve().then(function () {
    return require('./pullquote');
  });
});
exports.default = {
  Code: Code,
  Html: Html,
  Preformatted: Preformatted,
  Pullquote: Pullquote
};